'use client';

import { Breadcrumb, BreadcrumbList, BreadcrumbItem, BreadcrumbSeparator, BreadcrumbPage } from '@ui/components/ui/breadcrumb';
import { Button } from '@ui/components/ui/button';
import { useBreadcrumb } from '@/contexts/app-context';
import Link from 'next/link';

export function DynamicBreadcrumb() {
  const { breadcrumbs } = useBreadcrumb();

  if (breadcrumbs.length === 0) {
    return null;
  }

  return (
    <div className="flex items-center gap-2">
      <Breadcrumb>
        <BreadcrumbList>
          {breadcrumbs.map((item, index) => (
            <div key={index} className="flex items-center">
              {index > 0 && <BreadcrumbSeparator className="mx-1" />}
              <BreadcrumbItem>
                {item.isCurrentPage ? <BreadcrumbPage>{item.label}</BreadcrumbPage> : <Link href={item.href || '#'}>{item.label}</Link>}
              </BreadcrumbItem>
            </div>
          ))}
        </BreadcrumbList>
      </Breadcrumb>

      {/* Render action buttons if present on current page item */}
      {breadcrumbs.map((item, index) =>
        item.isCurrentPage && item.action ? (
          <Button
            key={`action-${index}`}
            variant={item.action.variant || 'default'}
            size={item.action.size || 'sm'}
            onClick={item.action.onClick}
            disabled={item.action.disabled}
            aria-label={item.action.ariaLabel}
          >
            {item.action.icon}
          </Button>
        ) : null
      )}
    </div>
  );
}
